import styled from 'styled-components';
import colors from 'constants/colors';

export const Container = styled.div`
  width: 100%;  
  background-color: ${colors.black1};
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${colors.silver};
`;

export const RemainingContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  letter-spacing: 1px;
`;

export const Title = styled.div`
  width: 100%;
  font-size: 17px;
  font-weight: 300;
  color: ${colors.silver};
  margin-bottom: 10px;
`;

export const RemainingItem = styled.a`
  width: 100%;
  padding: 5px 0;
  margin-bottom: 10px;
  border-bottom: 1px solid ${colors.charcoal};
  text-decoration: none;
  cursor: pointer;

  div{
    letter-spacing: 0.5px;
    color: ${colors.white};
    :nth-child(1) {
      font-size: 12px;
      font-weight: 300;
    }
    :nth-child(2) {
      font-size: 14px;
      font-weight: 600;
    }
  }
`;
